module.exports = __webpack_public_path__ + "static/media/bkg-wall-e-04.55f2be75.jpg";